// Montos editables con separador de miles: `1,500`, `1,799.99`. Funciones puras.

const WHOLE = new Intl.NumberFormat('es-MX', { maximumFractionDigits: 0 });
const WITH_CENTS = new Intl.NumberFormat('es-MX', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

/** Formatea con comas de miles; los centavos solo aparecen si el monto los tiene. */
export function formatAmount(value: number, decimals: 0 | 2 = 2): string {
    const cents = Math.round(value * 100);
    if (decimals === 0 || cents % 100 === 0) return WHOLE.format(Math.round(value));
    return WITH_CENTS.format(cents / 100);
}

/** Lee lo tecleado o pegado (`1,500`, `$1500.5`); `null` si no es un monto válido. */
export function parseAmount(text: string, decimals: 0 | 2 = 2): number | null {
    const clean = text.replace(/[,\s$]/g, '');
    const pattern = decimals === 0 ? /^\d+$/ : /^(\d+\.?\d{0,2}|\.\d{1,2})$/;
    if (!pattern.test(clean)) return null;
    const value = Number(clean);
    return Number.isFinite(value) ? value : null;
}

/** Lo tecleado con comas de miles en vivo: `6300` → `6,300`, `1507.4` → `1,507.4`. */
export function groupTypedAmount(text: string, decimals: 0 | 2 = 2): string {
    const kept = text.replace(decimals === 0 ? /[^\d]/g : /[^\d.]/g, '');
    const dot = kept.indexOf('.');
    const intPart = dot === -1 ? kept : kept.slice(0, dot);
    const fracPart =
        dot === -1
            ? null
            : kept
                  .slice(dot + 1)
                  .replace(/\./g, '')
                  .slice(0, 2);
    const grouped = intPart.replace(/^0+(?=\d)/, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fracPart === null ? grouped : `${grouped === '' ? '0' : grouped}.${fracPart}`;
}

/** Posición en `formatted` tras los mismos `digits` dígitos (o punto) que había antes del cursor. */
export function caretAfterDigits(formatted: string, digits: number): number {
    if (digits <= 0) return 0;
    let seen = 0;
    for (let i = 0; i < formatted.length; i += 1) {
        if (/[\d.]/.test(formatted[i])) seen += 1;
        if (seen === digits) return i + 1;
    }
    return formatted.length;
}
